import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
})
export class ForgotPasswordComponent implements OnInit {

  email: string;
  idRequest: string;
  failMessage: string;
  isLoading: boolean = false;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private authService: AuthenticationService) {}

  ngOnInit() {
    var uniqueId = null;
    this.route.queryParams.subscribe(params => {
      uniqueId = params['uniqueSourceId'];
    });
    if(uniqueId != null){
      if (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
        ) {
          window.location.href = 'aplcp://forgotpassword?uniqueSourceId=' + uniqueId;
          this.router.navigate([`/account/forgotpassword/${uniqueId}`]);
        } else {
          this.router.navigate([`/account/forgotpassword/${uniqueId}`]);
        }
    }
  }
  send(isValid: any){
    if(isValid){
      this.isLoading = true;
      this.authService.forgotPassword(this.email,
        resp =>{
          this.isLoading = false;
          if(resp.alert.code == 200){
            this.idRequest = resp.data;
            $('#success').modal('show');
          }else{
            this.failMessage = resp.alert.message;
            $('#fail').modal('show');
          }
        },
        err =>{
          this.isLoading = false;
          this.failMessage = err;
            $('#fail').modal('show');
        });
    }
  }
  resend(){
    // if(this.idRequest != null){
    //   this.authService.resendEmail(this.idRequest,
    //     resp =>{},
    //     err =>{});
    // }
    this.router.navigate(['/']);
  }
}
